namespace GeniuzPOS.Lookups {
    export interface VwConceptRow {
        Id?: number;
        ConceptCode?: string;
        ConceptName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IsActive?: number;
        FullName?: string;
    }

    export namespace VwConceptRow {
        export const idProperty = 'ConceptCode';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwConcept';
        export const lookupKey = 'Lookups.VwConcept';

        export function getLookup(): Q.Lookup<VwConceptRow> {
            return Q.getLookup<VwConceptRow>('Lookups.VwConcept');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ConceptCode = "ConceptCode",
            ConceptName = "ConceptName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IsActive = "IsActive",
            FullName = "FullName"
        }
    }
}
